module.exports = {"130927100":"南皮镇","130927101":"冯家口镇","130927102":"寨子镇","130927103":"鲍官屯镇","130927104":"王寺镇","130927105":"乌马营镇","130927200":"大浪淀乡","130927201":"刘八里乡","130927202":"潞灌乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130927.json
// module id = 221
// module chunks = 0